import React from 'react'
import Box from "@mui/material/Box";
import LupaIcon from "../../../src/svg/lupaIcon";

const SearchCompany = ({ theme, valor, setValor = (() => { }), floating = true, placeholder = "" }) => {
    return (
        <div className={"search " + (floating ? "floating-search" : "")} style={{ border: `1.5px solid ${theme} ` }}>
            <Box sx={{ marginLeft: '5px' }}>
                <LupaIcon size={32} color={theme} />
            </Box>
            <input
                type="search"
                id="buscador"
                placeholder={`Buscar ${placeholder}...`}
                style={{ border: `1px solid ${theme}`, backgroundColor: 'var(--blanco-claro)' }}
                value={valor}
                onChange={setValor}
            />
        </div>
    )
}

export default SearchCompany